/**
 * Project Row Type Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.projectRowTypeFormatter = function(value, row) {
    let html = '';
    if (value) {
        switch (value) {
            case 'default':
                html += '<span class="badge rounded-pill badge-project-row-type-default" data-toggle="tooltip" data-placement="top" title="'+__('Default')+'">';
                html += '<i class="fas fa-list-ul"></i>';
                html += '</span>';
                break;
            case 'task':
                html += '<span class="badge rounded-pill badge-project-row-type-task" data-toggle="tooltip" data-placement="top" title="'+__('Task')+'">';
                html += '<i class="fas fa-list-check"></i>';
                html += '</span>';
                break;
        }
    }
    return html;
}
